module.exports = __webpack_public_path__ + "static/media/working_professionalnew.e8922ebc.svg";